export const NOTIFICATIONS_OPEN_SYSTEM = 'NOTIFICATIONS_OPEN_SYSTEM';

export const NOTIFICATIONS_CLOSE_SYSTEM = 'NOTIFICATIONS_CLOSE_SYSTEM';

export const NOTIFICATIONS_OPEN_VALIDATION = 'NOTIFICATIONS_OPEN_VALIDATION';

export const NOTIFICATIONS_CLOSE_VALIDATION = 'NOTIFICATIONS_CLOSE_VALIDATION';
